module.exports = __webpack_public_path__ + "img/why-decoration-1.30b55d13.jpg";